import {Chatroom, TaskData} from '../../models';
import axios from 'axios';
import { constants } from '../../constants';

export const getMemberDetail = (memberId: string, room: Chatroom, day: number) => {
  const token = localStorage.getItem('token');
  return axios.get<{result: TaskData[]}>(
    `${constants.endpoint}/users/${memberId}`, {
      params: {
        chatroomId: room.id,
        activityId: room.activity.id,
        pushOrder: day,
      },
      headers: {
        Authorization: `bearer ${token}`,
      },
    }
  ).then(response => response.data);
};
